import MenuPage from "./Menu"
import ConfirmPage from "./ConfirmPage"
import WePay from "./WePay/WePay.page"
import PaymentProcessing from "./PaymentProcessing/PaymentProcessing.page"
import PaymentSuccess from "./PaymentSuccess/PaymentSuccess.page"
import PaymentFail from "./PaymentFail/PaymentFail.page"

export {
    MenuPage,
    ConfirmPage,
    WePay,
    PaymentProcessing,
    PaymentSuccess,
    PaymentFail
}